import React from 'react';
import './pharmacology.css';
import { FaFlask, FaPills, FaMicroscope, FaUserMd, FaChartLine, FaBook } from 'react-icons/fa';
import { Link } from 'react-router-dom';



function PharmacologyCourse() {
  return (
    <div className="pharmacology-page">
      {/* Hero Banner */}
      <section className="pharm-hero">
        <div className="pharama-hero-overlay">
          <h1>Pharmacology Programs</h1>
          <p className="subtitle">Master drug actions, therapeutic applications, and clinical pharmacology</p>

        </div>
      </section>

      {/* Program Options */}
      <section className="program-options">
        <div className="container">
          <h2 className="section-title">Choose Your Pathway</h2>
          <div className="program-cards">
            {/* Certificate Program */}
            <div className="program-card cert-card">
              <div className="program-header">
                <FaBook className="program-icon" />
                <h3>Certificate in Pharmacology</h3>
                <p className="program-duration">6 Months | Part-time</p>
              </div>
              <div className="program-body">
                <h4>Core Focus Areas:</h4>
                <ul>
                  <li>Fundamentals of Drug Actions</li>
                  <li>Basic Pharmacokinetics</li>
                  <li>Major Drug Classes</li>
                  <li>Therapeutic Principles</li>
                </ul>
                <div className="program-details">
                  <p><strong>Entry Requirements:</strong> A/Ls with Biology/Chemistry</p>
                  <p><strong>Credits:</strong> 20</p>
                </div>
              </div>
              <button className="program-cta">Program Details</button>
            </div>

            {/* Diploma Program */}
            <div className="program-card diploma-card">
              <div className="program-header">
                <FaUserMd className="program-icon" />
                <h3>Diploma in Clinical Pharmacology</h3>
                <p className="program-duration">1 Year | Full-time</p>
                <div className="featured-badge">Most Popular</div>
              </div>
              <div className="program-body">
                <h4>Advanced Curriculum:</h4>
                <ul>
                  <li>Advanced Pharmacodynamics</li>
                  <li>Drug Development Process</li>
                  <li>Clinical Trial Methodology</li>
                  <li>Pharmacogenomics</li>
                  <li>Research Project</li>
                </ul>
                <div className="program-details">
                  <p><strong>Entry Requirements:</strong> Certificate in Pharmacology or Related Field</p>
                  <p><strong>Credits:</strong> 45</p>
                </div>
              </div>
              <button className="program-cta">Program Details</button>
            </div>
          </div>
        </div>
      </section>

      {/* Program Comparison */}
      <section className="program-comparison">
        <div className="container">
          <h2 className="section-title">Program Comparison</h2>
          <div className="comparison-table">
            <table>
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Certificate</th>
                  <th>Diploma</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Program Level</td>
                  <td>Entry-level</td>
                  <td>Advanced</td>
                </tr>
                <tr>
                  <td>Hands-on Labs</td>
                  <td>Basic techniques</td>
                  <td>Advanced research methods</td>
                </tr>
                <tr>
                  <td>Clinical Exposure</td>
                  <td>Observational</td>
                  <td>Practical rotations</td>
                </tr>
                <tr>
                  <td>Career Outcomes</td>
                  <td>Pharmacy Assistant</td>
                  <td>Clinical Researcher</td>
                </tr>
                <tr>
                  <td>Further Education</td>
                  <td>Pathway to Diploma</td>
                  <td>Bachelor's Degree</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Learning Experience */}
      <section className="learning-experience">
        <div className="container">
          <h2 className="section-title">Our Learning Approach</h2>
          <div className="experience-grid">
            <div className="experience-card">
              <FaFlask className="exp-icon" />
              <h3>Laboratory Training</h3>
              <p>Modern equipment for drug analysis and pharmacological testing</p>
            </div>
            <div className="experience-card">
              <FaPills className="exp-icon" />
              <h3>Case-Based Learning</h3>
              <p>Real-world therapeutic scenarios and problem-solving</p>
            </div>
            <div className="experience-card">
              <FaMicroscope className="exp-icon" />
              <h3>Research Projects</h3>
              <p>Opportunities to contribute to ongoing pharmacological research</p>
            </div>
          </div>
        </div>
      </section>

      {/* Career Support */}
      <section className="career-support">
        <div className="container">
          <h2 className="section-title">Career Pathways</h2>
          <div className="career-stats">
            <div className="stat-card">
              <div className="stat-number">94%</div>
              <div className="stat-label">Diploma Employment Rate</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">85%</div>
              <div className="stat-label">Certificate Employment Rate</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">18%</div>
              <div className="stat-label">Industry Growth Projection</div>
            </div>
          </div>
          <div className="career-grid">
            <div className="career-path">
              <h3>Certificate Graduates</h3>
              <ul>
                <li>Pharmaceutical Sales Representative</li>
                <li>Pharmacy Technician</li>
                <li>Clinical Trial Assistant</li>
              </ul>
            </div>
            <div className="career-path">
              <h3>Diploma Graduates</h3>
              <ul>
                <li>Clinical Research Associate</li>
                <li>Drug Safety Specialist</li>
                <li>Regulatory Affairs Officer</li>
                <li>Pharmacology Lab Technician</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="pharm-cta">
        <div className="container">
          <h2>Ready to Advance in Pharmacology?</h2>
          <p>Next intake begins August 2025 - Limited seats available</p>
          <div className="cta-buttons">
            <Link to="/apply" className="primary-cta">Apply Now</Link>
   
        
          </div>
        </div>
      </section>
    </div>
  );
}

export default PharmacologyCourse;